export { default as AwsException } from './AwsException';
